// src/auth/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";


const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // Estado local
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [refresh, setRefresh] = useState(null);
  const [loading, setLoading] = useState(true);
  

  // Verifica si hay tokens guardados al cargar la app
        useEffect(() => {
        const storedToken = localStorage.getItem('token');
        const storedRefresh = localStorage.getItem('refresh');
        if (storedToken && storedRefresh) {
            setToken(storedToken);
            setRefresh(storedRefresh);
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
        setLoading(false);
        }, []);
  // Función para iniciar sesión
const login = async (username, password) => {
  //console.log('Intentando login...', username);
  const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/token/`, {
    username,
    password,
  });
  //console.log('Respuesta de backend:', res.data);

  localStorage.setItem('token', res.data.access);
  localStorage.setItem('refresh', res.data.refresh);
  //console.log('Token guardado en localStorage:', localStorage.getItem('token'));

  setToken(res.data.access);
  setRefresh(res.data.refresh);
  setIsAuthenticated(true);

  // Verifica 1 segundo después si el token sigue
  setTimeout(() => {
    //console.log('Token sigue en localStorage (1 seg después):', localStorage.getItem('token'));
  }, 1000);
};


  // Función para cerrar sesión
        const logout = () => {
        //onsole.log('%c [LOGOUT INVOCADO] ', 'background: red; color: white;', new Date().toISOString());
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
        setToken(null);
        setRefresh(null);
        setIsAuthenticated(false);
        };


  // Refresca el access token si está por expirar (ej: menos de 2 min)
const checkAndRefreshToken = async () => {
  console.log('checkAndRefreshToken ejecutada')
  // Solo continuar si token y refresh existen Y son cadenas de cierto largo
  if (!token || !refresh || typeof token !== 'string' || token.length < 50) {
    //console.log('Token o refresh inválido, saliendo del check.');
    return;
  }
  try {
    const decoded = jwtDecode(token);
    const exp = decoded.exp * 1000;
    const now = Date.now();
    const segundosRestantes = Math.floor((exp - now) / 1000);

    // 🟢 Agrega este log
    console.log(`[Token] Hora actual: ${new Date(now).toLocaleTimeString()} | Expira: ${new Date(exp).toLocaleTimeString()} | Segundos restantes: ${segundosRestantes}`);

    if (exp - now < 2 * 60 * 1000) {
      // Token a punto de expirar, refrescar
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/token/refresh/`, {
        refresh: refresh,
      });
      localStorage.setItem('token', res.data.access);
      setToken(res.data.access);
    }
  } catch (err) {
    //console.log('Error decodificando el token:', err);
    // Solo hacer logout si ambos existen y tienen tamaño válido
    if (token && refresh && token.length > 50 && refresh.length > 50) {
      logout();
    }
  }
};



  // Opcional: Ejecuta el chequeo antes de cada request importante


  // Valor expuesto por el context
  const value = {
    isAuthenticated,
    token,
    refresh,
    login,
    logout,
    checkAndRefreshToken,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
